export const SET_PROPERTY_DATA_JOBS_RESULTS = 'SET_PROPERTY_DATA_JOBS_RESULTS';
export const SET_IS_FETCHING_JOBS = 'SET_IS_FETCHING_JOBS';
